import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress, Box, TextField, Typography } from '@mui/material';
import { setLoadSuccess, setLoadFailure } from '../../store/slices/loadSlice';
import { useFetchTodaysLoad } from './vanuser.hooks';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../../App.css';

export default function SearchProduct({ vanid }) {
  const dispatch = useDispatch();
  const { loadItems: loadDetails } = useSelector((state) => state.load);
  const { refetch, isFetching } = useFetchTodaysLoad({ enabled: false });

  const [search, setSearch] = useState('');
  const hasLoad = Array.isArray(loadDetails) && loadDetails.length > 0;

  useEffect(() => {
    const fetchData = async () => {
      if (!hasLoad) {
        const result = await refetch();
        if (result.status === 'success' && result.data) {
          dispatch(setLoadSuccess(result.data));
        } else if (result.status === 'error') {
          dispatch(setLoadFailure(result.error?.message || 'Failed to fetch load'));
        }
      }
    };
    fetchData();
  }, [hasLoad, refetch, dispatch]);

  const filteredDetails = loadDetails.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>Search Loads</Typography>

      <TextField
        label="Search by product name"
        variant="outlined"
        fullWidth
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
      />

      {isFetching ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="200px">
          <CircularProgress />
        </Box>
      ) : (
        <div className="responsive-table-container">
          <Table className="van-orders-table">
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Product Code</Th>
                <Th>Box</Th>
                <Th>Barcode</Th>
                <Th>Price</Th>
             
              </Tr>
            </Thead>
            <Tbody>
              {filteredDetails.map((item) => (
                <Tr key={item.id}>
                  <Td>{item.name}</Td>
                  <Td>{item.productcode}</Td>
                  <Td>{item.boxnumber}</Td>
                  <Td>{item.barcode}</Td>
                  <Td>{item.price}</Td>
       
                </Tr>
              ))}
              {filteredDetails.length === 0 && (
                <Tr>
                  <Td colSpan="7" style={{ textAlign: 'center' }}>
                    No products found.
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
      )}
    </Box>
  );
}
